import React from 'react';
import { InternetBankingStyled } from './styled';
import { userService } from 'apiService';
import { toast } from 'react-toastify';

export const InternetBanking = (props) => {
  const { children, invoiceID, amount, callback } = props;

  const handleClickPayment = () => {
    const { OmiseCard } = window;
    OmiseCard.configure({
      publicKey: process.env.REACT_APP_OMISE_PUBLIC_KEY,
    });
    OmiseCard.open({
      amount: Number(amount) * 100,
      defaultPaymentMethod: 'internet_banking',
      submitFormTarget: '#checkout-form',
      onCreateTokenSuccess: (nonce) => {
        /* Handler on token or source creation.  Use this to submit form or send ajax request to server */
        if (nonce) {
          handleSubmit(nonce);
        } else {
          toast.error('ชำระเงินไม่สำเร็จ กรุณาชำระภายหลัง');
        }
      },
      onFormClosed: () => {
        /* Handler on form closure. */
      },
    });
  };

  const handleSubmit = async (token) => {
    let params = {
      gateway: 'omise',
      type: 'internet_banking',
      token: token,
    };
    let res = await userService.POST_PAYMENT_DETAIL(invoiceID, params);
    if (res && res.success) {
      toast.success('ชำระสำเร็จ');
      window.location.replace(res.data.authorize_uri);
      callback && callback();
    }
  };

  return (
    <InternetBankingStyled>
      <div onClick={handleClickPayment}>{children}</div>
    </InternetBankingStyled>
  );
};
